import React from 'react'
import { useNavigation, useUndoRedo } from '@sketch-hq/sketch-prototype-player'
import { Tooltip, TooltipShortcut } from '@sketch/components'
import {
  Container,
  Divider,
  Button,
  RestartIcon,
  GoForwardsButton,
  GoBackwardsButton,
} from './PrototypeControls.styles'

type HistoryNavigationProps = {
  className?: string
  initialArtboardId: string
}

export function PrototypeControls({
  className,
  initialArtboardId,
}: HistoryNavigationProps) {
  const { restartPrototypeFrom } = useNavigation()
  const { undo, redo, canUndo, canRedo } = useUndoRedo()

  return (
    <Container className={className}>
      <Tooltip
        placement="bottom"
        content={
          <>
            Restart Prototype
            <TooltipShortcut>Press R</TooltipShortcut>
          </>
        }
        disabled={!canUndo}
      >
        <Button
          type="button"
          aria-label="Restart prototype"
          disabled={!canUndo}
          onClick={() => restartPrototypeFrom(initialArtboardId)}
        >
          <RestartIcon />
        </Button>
      </Tooltip>
      <Divider />
      <Tooltip
        placement="bottom"
        content={
          <>
            Go Back
            <TooltipShortcut>Press left arrow</TooltipShortcut>
          </>
        }
        disabled={!canUndo}
      >
        <Button
          type="button"
          aria-label="Undo prototype action"
          disabled={!canUndo}
          onClick={undo}
        >
          <GoBackwardsButton />
        </Button>
      </Tooltip>
      <Tooltip
        placement="bottom"
        content={
          <>
            Go Forward
            <TooltipShortcut>Press right arrow</TooltipShortcut>
          </>
        }
        disabled={!canRedo}
      >
        <Button
          type="button"
          aria-label="Redo prototype action"
          disabled={!canRedo}
          onClick={redo}
        >
          <GoForwardsButton />
        </Button>
      </Tooltip>
    </Container>
  )
}
